import { UserAction } from "@brookbush/types";

import { SignUp, useAuth } from "@clerk/nextjs";
import { getCookie } from "cookies-next";
import { useRouter } from "next/compat/router";
import Link from "next/link";
import posthog from "posthog-js";

import { SecondaryLayout } from "~/layouts";
import type { Layout, NextPageWithProps } from "~/types";

const SignUpPage: NextPageWithProps = () => {
	const { query } = useRouter() ?? {};
	const { redirect_url } = query as { redirect_url?: string };

	return (
		<div className="flex w-full max-w-md flex-col items-center gap-8 rounded-xl border bg-white phablet:px-10 px-4 phablet:py-8 py-6 shadow shadow-slate-200 dark:bg-slate-800 dark:shadow-slate-950">
			<SignUp
				path="/sign-up"
				unsafeMetadata={{
					ctaClick: getCookie(`${UserAction.SIGN_UP}:cta-click`),
					signUpPath: redirect_url ?? "/sign-up",
					isTrialUser:
						!!getCookie("is-trial-user") || !!getCookie("referrer-id"),
					ipAddress: getCookie("ip-address"),
					userAgent: getCookie("user-agent"),
					auditedCourseId: getCookie("audited-course-id"),
					auditedVideoId: getCookie("audited-video-id"),
					auditedGlossaryTermId: getCookie("audited-glossary-term-id"),
					referrerId: getCookie("referrer-id"),
					shouldReceiveGiftCard: getCookie("utm-gift-card"),
					posthogSessionId: posthog.get_session_id(),
				}}
			/>

			<div className="flex flex-col gap-6">
				<p className="text-center">
					Already have an account?{" "}
					<Link
						href="/sign-in"
						className="text-sky-600 hover:underline dark:text-sky-300"
					>
						Sign In
					</Link>
				</p>

				<p className="flex gap-6 text-sm">
					<Link
						href="/terms-of-service"
						target="_blank"
						className="font-medium hover:underline"
					>
						Terms of Service
					</Link>{" "}
					<Link
						href="/privacy-policy"
						target="_blank"
						className="font-medium hover:underline"
					>
						Privacy Policy
					</Link>
				</p>
			</div>
		</div>
	);
};

const Layout: Layout = ({ children }) => {
	const { isLoaded } = useAuth();

	return <SecondaryLayout isLoading={!isLoaded}>{children}</SecondaryLayout>;
};

SignUpPage.Layout = Layout;

export default SignUpPage;
